import { createBlockCanvas } from "./createBlockCanvas";
import { createSmallCanvas } from "./createSmallCanvas";

export function drawLastHumanCanvas({
  currFrameCanvas,
  screenCanvas,
  blockSize,
  smallCanvasSize,
  allowGhosting,
  ghostingLevel,
  useRealColours,
  blockColour,
  maxBlockFraction,
  blockShape,
  fadeEdges,
  showCubeFront,
  showCubeBack,
}) {
  if (currFrameCanvas) {
    const smallCanvas = createSmallCanvas(currFrameCanvas, smallCanvasSize);
    const blockCanvas = createBlockCanvas({
      inputCanvas: smallCanvas,
      blockSize,
      usePixelColour: useRealColours,
      blockColour,
      maxSizeMultiplier: maxBlockFraction,
      blockShape,
      fadeEdges,
    });

    const ctx = screenCanvas.getContext("2d");
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    // clear rect
    const fillColour = allowGhosting ? `rgba(0,0,0,${ghostingLevel})` : "black";
    ctx.fillStyle = fillColour;
    ctx.fillRect(0, 0, screenCanvas.width, screenCanvas.height);

    if (showCubeBack) {
      const offsetX = screenCanvas.width / 8;
      const offsetY = screenCanvas.height / 8;

      const frontLineWidth = 6;
      const backLineWidth = frontLineWidth / 1.5;
      const backOpacity = 1;

      // cube edges
      drawDoubleLine(
        [0, 0],
        [offsetX, offsetY],
        ctx,
        backLineWidth,
        blockColour,
        backOpacity
      );

      drawDoubleLine(
        [screenCanvas.width, 0],
        [screenCanvas.width - offsetX, offsetY],
        ctx,
        backLineWidth,
        blockColour,
        backOpacity
      );

      drawDoubleLine(
        [0, screenCanvas.height],
        [offsetX, screenCanvas.height - offsetY],
        ctx,
        backLineWidth,
        blockColour,
        backOpacity
      );

      drawDoubleLine(
        [screenCanvas.width, screenCanvas.height],
        [screenCanvas.width - offsetX, screenCanvas.height - offsetY],
        ctx,
        backLineWidth,
        blockColour,
        backOpacity
      );

      drawDoubleLineRect({
        lineWidth: backLineWidth,
        ctx,
        blockColour,
        screenCanvas,
        opacity: backOpacity,
        offsetX: offsetX - frontLineWidth,
        offsetY: offsetY - frontLineWidth,
      });

      ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
      ctx.fillRect(0, 0, screenCanvas.width, screenCanvas.height);
    }
    // draw image
    ctx.drawImage(blockCanvas, 0, 0);

    // cube front
    // ctx.strokeStyle = allowGhosting
    //   ? "rgba(255,255,255,0.6)"
    //   : "rgba(255,255,255,0.8)";

    if (showCubeFront) {
      drawDoubleLineRect({
        lineWidth: 3,
        ctx,
        blockColour,
        screenCanvas,
        opacity: 1,
      });
    }
  }
}

const drawDoubleLine = (pt1, pt2, ctx, lineWidth, blockColour, opacity) => {
  ctx.beginPath();
  ctx.strokeStyle = `rgba(255,255,255,${opacity})`;
  ctx.lineWidth = lineWidth * 2;
  ctx.moveTo(...pt1);
  ctx.lineTo(...pt2);
  ctx.stroke();

  ctx.beginPath();
  ctx.strokeStyle = blockColour;
  ctx.lineWidth = lineWidth;
  ctx.moveTo(...pt1);
  ctx.lineTo(...pt2);
  ctx.stroke();
};

const drawDoubleLineRect = ({
  lineWidth = 4,
  ctx,
  blockColour,
  screenCanvas,
  opacity,
  offsetX = 0,
  offsetY = 0,
}) => {
  const backLineWidth = lineWidth * 2;

  const offsetW = screenCanvas.width - offsetX * 2;
  const offsetH = screenCanvas.height - offsetY * 2;

  const halfBackLineWidth = backLineWidth / 2;
  const backOffset = backLineWidth / 2;

  ctx.strokeStyle = `rgba(255,255,255,${opacity})`;
  ctx.lineWidth = backLineWidth;
  ctx.strokeRect(
    offsetX + backOffset,
    offsetY + backOffset,
    offsetW - backLineWidth,
    offsetH - backLineWidth
  );

  ctx.strokeStyle = blockColour;
  ctx.lineWidth = lineWidth;
  ctx.strokeRect(
    offsetX + halfBackLineWidth,
    offsetY + halfBackLineWidth,
    offsetW - halfBackLineWidth * 2,
    offsetH - halfBackLineWidth * 2
  );
};
